import axios from "axios";
import React, { useEffect, useState } from "react";
import { BsFillChatTextFill } from "react-icons/bs";
import { MdOutlineClose } from "react-icons/md";
import { api_url, AXIOS_HEADER } from "../../constants/data";
import { FileUploader } from "react-drag-drop-files";
import moment from "moment";

export default function CommentsModal({id, close}) {
    const [isVisible, setIsVisible] = useState(false);
    const [showChat, setShowChat] = useState(true);
    const [formData, setFormData] = useState({ description: '' });
    const [comments, setComments] = useState([]);   
    const [selectedFile, setSelectedFile] = useState(null)
    const fileTypes = ["jpg", "png", "pdf", "xlxs", "doc"];
    const refetch = () => {
        axios.post(`${api_url}/comments`, {task_id: id}, AXIOS_HEADER)
        .then((res) => {
            setComments(res.data)
        })
        .catch((err) => {
            console.log(err)
        })
    } 
      
    useEffect(() => {
        refetch()
    }, [])
    
    const handleChange = (file) => {
        setSelectedFile(file);
    };

    const submit = () => {
        if(formData.description === '' && selectedFile === null) {
            return;
        }

        const fd = new FormData();
        fd.append('task_id', id);
        fd.append('body', formData.description);
        fd.append('file', selectedFile);

        axios.post(`${api_url}/add-comment`, fd, AXIOS_HEADER)
            .then((res) => {
                setFormData({ description: '' });
                setSelectedFile(null);
                refetch()
            })
            .catch((err) => {
                console.log(err)
            })  

    };

    return (
        <div className="modal">
            <div className="modal_wrapper">
                <div className="modal_header">
                    <p>კომენტარები ({ comments.length })</p>
                    <MdOutlineClose style={{cursor: 'pointer'}} onClick={close}/>
                </div>
                <div className="modal_body">
                    <div className="comments_box">
                        { comments && comments.map((comment, index) => (
                            <div className="comment_item">
                                <div className="comment_user">
                                    <img src={comment.user.image} alt="" />
                                </div>
                                <div className="comment_box">
                                    <p className="comment_date">
                                        {comment.user.name} {comment.user.lastname} 
                                        <span>{moment(comment.created_at).format("YYYY-MM-DD HH:mm:ss")}</span>
                                        
                                        {comment.file && <a href={comment.file} target="_blank"> ფაილი</a> }
                                    </p>
                                    <p>{comment.body}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="comment_form">
                        <div className="form_control w-100">
                            <textarea placeholder="დაწერე კომენტარი..." style={{resize: 'none', width: '100%'}} rows={6} value={formData.description} onChange={(e) => setFormData({...formData, description: e.target.value })} ></textarea>
                        </div>
                        <div className="drop_file w-100 sm_drop_file">
                            <FileUploader handleChange={handleChange} name="file" types={fileTypes}  >
                                { selectedFile ? (
                                    <>
                                        <p>Selected file: { selectedFile.name }</p>
                                        <p onClick={() => setSelectedFile(null)} >Remove</p>
                                    </>
                                ) : (
                                    <>
                                        <p>Drag & Drop files or choose files</p>
                                        <span> <img src="/icons/information-circle.png" alt="" /> Max file size: 10 MB</span>
                                    </>
                                ) }
                                
                            </FileUploader>
                        </div>
                        <div className="form_control w-100">
                            <button type="submit" className="submitBtn" onClick={submit}>შესვლა</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
